interface Props {
	content: {
		contentType: string;
		properties: {
			script: string;
			heading: string;
		};
	};
	settings: {
		properties: {
			appendLastQuerystring: boolean;
			height?: string;
		};
	};
}

export const mapScriptModule = ({ content, settings }: Props): Content.ContentModule => {
	return {
		documentType: content?.contentType,
		content: {
			properties: {
				script: content.properties.script,
				heading: content.properties.heading,
			},
		},
		settings,
	};
};
